module.exports = __webpack_public_path__ + "static/media/test.1c28bf22.png";